import React, { useEffect, useState } from 'react';
import '../About/About.css';

const About = () => {
  // State to handle the running count for each number
  const [experience, setExperience] = useState(0);
  const [sqFtDelivered, setSqFtDelivered] = useState(0);
  const [projects, setProjects] = useState(0);
  const [consultants, setConsultants] = useState(0);

  // Increment counters smoothly
  useEffect(() => {
    const incrementValue = (endValue, setState) => {
      let startValue = 0;
      const interval = setInterval(() => {
        startValue += 1;
        setState(startValue);
        if (startValue >= endValue) clearInterval(interval);
      }, 50); // Adjust speed as needed
    };

    incrementValue(60, setExperience);
    incrementValue(15, setSqFtDelivered);
    incrementValue(100, setProjects);
    incrementValue(10, setConsultants);
  }, []);

  return (
    <section className="about-section">
      <div className="about-content">
        <h2>About <span className="highlight">Trehan IRIS</span></h2>
        <p>
          Established in the early ‘50s, Trehan IRIS has over six decades of
          unprecedented experience in the construction field. The Trehan Group
          has executed prestigious projects for CPWD, DDA, PWD across Delhi- NCR.
        </p>
        <p>
          Right from its inception, Trehan IRIS envisioned the value of
          functional and sustainable real estate developments. The group has
          executed super-specialty real-estate projects utilizing the strengths
          of modern techniques, innovative designs, and international management
          processes.
        </p>
        <p>
          Ruling the realm of real estate for three generations, the group has
          developed and delivered key landmarks of Delhi-NCR like IRIS Tech
          Park, IRIS Broadway, IRIS Cyber Tower, IRIS Cyber Square, IRIS Farms,
          besides other construction marvels.
        </p>
        <p>
          With expertise in group housing projects, high-end luxury residences,
          farms houses, commercial & retail, IT parks and hotels, Trehan Group
          has successfully delivered 15+ Million Sq Ft space with over 100
          projects executed.
        </p>
      </div>
      <div className="about-stats">
        <div className="stat">
          <h3>{experience}+</h3>
          <p>YEARS OF CONSTRUCTION EXPERIENCE</p>
        </div>
        <div className="stat">
          <h3>{sqFtDelivered}+</h3>
          <p>MILLION SQ. FT. DELIVERED</p>
        </div>
        <div className="stat">
          <h3>{projects}+</h3>
          <p>PROJECTS DELIVERED</p>
        </div>
        <div className="stat">
          <h3>{consultants}+</h3>
          <p>INTERNATIONAL DESIGN CONSULTANTS</p>
        </div>
      </div>
    </section>
  );
};

export default About;
